import React from 'react'
import classnames from 'classnames'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { SORT_TYPES } from '../../constants'

import CloseIcon from '../common/icons/CloseIcon'

const SortPopup = ({ uiStore, dataStore, t }) => {
  const onCloseClick = () => {
    uiStore.hideSortPopup()
  }

  return (
    <div className='choose-add-type choose-add-type--sort'>
      <button
        type='button'
        className={classnames({ 'choose-add-type__btn': true, 'choose-add-type__btn--sort': true, selected: uiStore.selectedSortType === SORT_TYPES.ASC })}
        onClick={(e) => {
          const extraConfig = { sorting: { attr: 'name', dir: 'asc', is_owner: true } }
          dataStore.sortTargetGroups(extraConfig.sorting)
          uiStore.hideSortPopup()
          uiStore.selectedSortType = SORT_TYPES.ASC
          localStorage.setItem('leftDrawerSortType', SORT_TYPES.ASC)
        }}
      >
        {t('SORT_POPUP.ASC')}
      </button>
      <button
        type='button'
        className={classnames({ 'choose-add-type__btn': true, 'choose-add-type__btn--sort': true, selected: uiStore.selectedSortType === SORT_TYPES.DESC })}
        onClick={(e) => {
          const extraConfig = { sorting: { attr: 'name', dir: 'desc', is_owner: true } }
          dataStore.sortTargetGroups(extraConfig.sorting)
          uiStore.hideSortPopup()
          uiStore.selectedSortType = SORT_TYPES.DESC
          localStorage.setItem('leftDrawerSortType', SORT_TYPES.DESC)
        }}
      >
        {t('SORT_POPUP.DESC')}
      </button>
      <button
        type='button'
        className={classnames({ 'choose-add-type__btn': true, 'choose-add-type__btn--sort': true, selected: uiStore.selectedSortType === SORT_TYPES.MODIFIED })}
        onClick={() => {
          dataStore.sortByModified()
          uiStore.hideSortPopup()
          uiStore.selectedSortType = SORT_TYPES.MODIFIED
          localStorage.setItem('leftDrawerSortType', SORT_TYPES.MODIFIED)
        }}
      >
        {t('SORT_POPUP.MODIFIED')}
      </button>
      <button onClick={onCloseClick} type='button' className='choose-add-type__close-btn'>
        <CloseIcon />
      </button>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(SortPopup)))
